import { ActionTypes, ReduxAction } from './types';
import { Dispatch } from 'redux';
import { VerkehrsartService } from '../../api';

export const getVerkehrsarten =
  (mandantId: number) => async (dispatch: Dispatch<ReduxAction>) => {
    new VerkehrsartService().getVerkehrsarten(mandantId).then(result => {
      dispatch({
        type: ActionTypes.GET_VERKEHRSARTEN,
        payload: result.data,
      });
    });
  };
